import { TableComponentContent } from '../../../types/elearning';
import { sanitizeElearningHtml } from '../../../utils/elearningHtml';

interface TableViewerProps {
  content: TableComponentContent;
}

export default function TableViewer({ content }: TableViewerProps) {
  const { hasHeader, rows } = content;

  if (!rows || rows.length === 0) {
    return (
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-4">
        <p className="text-sm text-gray-500">Empty table</p>
      </div>
    );
  }

  const headerRow = hasHeader && rows.length > 0 ? rows[0] : null;
  const dataRows = hasHeader ? rows.slice(1) : rows;

  return (
    <div className="overflow-x-auto mb-4">
      <table className="min-w-full divide-y divide-gray-200 border border-gray-200 rounded-lg">
        {headerRow && (
          <thead className="bg-gray-50">
            <tr>
              {headerRow.cells.map((cell, index) => (
                <th
                  key={index}
                  className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider"
                >
                  <div dangerouslySetInnerHTML={{ __html: sanitizeElearningHtml(cell.content) }} />
                </th>
              ))}
            </tr>
          </thead>
        )}
        <tbody className="bg-white divide-y divide-gray-200">
          {dataRows.map((row, rowIndex) => (
            <tr key={rowIndex} className="hover:bg-gray-50">
              {row.cells.map((cell, cellIndex) => (
                <td
                  key={cellIndex}
                  className="px-4 py-3 text-sm text-gray-700"
                >
                  <div dangerouslySetInnerHTML={{ __html: sanitizeElearningHtml(cell.content) }} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
